export default __webpack_public_path__ + "static/media/6 icon (1).1ad43d4a.jpg";